export enum TypePointLegends {
  hotel = 'HOTEL',
  airport = 'AIRPORT',
  favorite = 'FAVORITE',
}
